export default __webpack_public_path__ + "src/images/packages/villa-one-hilltop/7d220e116a22484209904678a1a5a501-1.jpg";